/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TutorialVideoDto interface.
 */
export function instanceOfTutorialVideoDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('videoId' in value) || value['videoId'] === undefined)
        return false;
    if (!('link' in value) || value['link'] === undefined)
        return false;
    if (!('imgAlt' in value) || value['imgAlt'] === undefined)
        return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined)
        return false;
    if (!('active' in value) || value['active'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
export function TutorialVideoDtoFromJSON(json) {
    return TutorialVideoDtoFromJSONTyped(json, false);
}
export function TutorialVideoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'videoId': json['videoId'],
        'link': json['link'],
        'imgAlt': json['imgAlt'],
        'displayOrder': json['displayOrder'],
        'active': json['active'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
export function TutorialVideoDtoToJSON(json) {
    return TutorialVideoDtoToJSONTyped(json, false);
}
export function TutorialVideoDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'videoId': value['videoId'],
        'link': value['link'],
        'imgAlt': value['imgAlt'],
        'displayOrder': value['displayOrder'],
        'active': value['active'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}
